import React from 'react';
import moment from 'moment';
import { Button, Icon, Message } from 'semantic-ui-react';
import { Link } from 'react-router-dom';

import { PropertyWalletActiveProcessDTO } from '../../../services/properties';
import {
  DetailsSection,
  DetailsSectionTitle,
  StyledTable,
  TableWrapper
} from '../styles';

type Props = {
  processes: PropertyWalletActiveProcessDTO[];
};

const STATUS_LABELS: Record<string, string> = {
  CREATED: 'Criado',
  IN_ANALYSIS: 'Em análise',
  PENDING: 'Pendente',
  IN_PROGRESS: 'Em andamento',
  DEBT_CONFESSION: 'Confissão de dívida',
  IN_ACCORD: 'Em acordo',
  MONTHLY_INDEMNITY: 'Indenização mensal',
  LMI_LMG_REACHED: 'Limite de indenização atingido',
  PRE_ACCIDENT: 'Pré-sinistro',
  RETURN_BILL: 'Retorno de cobrança'
};

const formatDate = (value?: string): string => {
  if (!value) return '—';
  const date = moment(value);
  return date.isValid() ? date.format('DD/MM/YYYY') : value;
};

const formatStatus = (value?: string): string => {
  if (!value) return '—';
  return STATUS_LABELS[value.toUpperCase()] || value;
};

const CondominiumActiveProcessesTable: React.FC<Props> = ({ processes }) => (
  <DetailsSection>
    <DetailsSectionTitle>Processos ativos</DetailsSectionTitle>
    {!processes.length ? (
      <Message info>
        <p style={{ margin: 0 }}>Nenhum processo ativo registrado para este imóvel.</p>
      </Message>
    ) : (
      <TableWrapper>
        <StyledTable celled striped compact>
          <StyledTable.Header>
            <StyledTable.Row>
              <StyledTable.HeaderCell>Criação</StyledTable.HeaderCell>
              <StyledTable.HeaderCell>Síndico</StyledTable.HeaderCell>
              <StyledTable.HeaderCell>Serviço</StyledTable.HeaderCell>
              <StyledTable.HeaderCell>Seguradora</StyledTable.HeaderCell>
              <StyledTable.HeaderCell>Imobiliária</StyledTable.HeaderCell>
              <StyledTable.HeaderCell>Status</StyledTable.HeaderCell>
              <StyledTable.HeaderCell textAlign="center"> </StyledTable.HeaderCell>
            </StyledTable.Row>
          </StyledTable.Header>
          <StyledTable.Body>
            {processes.map(process => (
              <StyledTable.Row key={process.id}>
                <StyledTable.Cell>{formatDate(process.createdAt)}</StyledTable.Cell>
                <StyledTable.Cell>{process.syndic || '—'}</StyledTable.Cell>
                <StyledTable.Cell>{process.service || 'Sinistro'}</StyledTable.Cell>
                <StyledTable.Cell>{process.insurer || '—'}</StyledTable.Cell>
                <StyledTable.Cell>{process.estate || '—'}</StyledTable.Cell>
                <StyledTable.Cell>{formatStatus(process.status)}</StyledTable.Cell>
                <StyledTable.Cell textAlign="center">
                  <Button
                    as={Link}
                    to={`/admin/claim_estates?claimId=${encodeURIComponent(process.id)}`}
                    icon
                    size="small"
                    color="purple"
                    aria-label={`Visualizar processo ${process.id}`}
                    title="Visualizar processo"
                  >
                    <Icon name="eye" />
                  </Button>
                </StyledTable.Cell>
              </StyledTable.Row>
            ))}
          </StyledTable.Body>
        </StyledTable>
      </TableWrapper>
    )}
  </DetailsSection>
);

export default CondominiumActiveProcessesTable;
